import React, { useEffect, useState } from "react";
import MainContainer from "../../../layout/MainContainer";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import {
  Autocomplete,
  Box,
  Button,
  CardMedia,
  Checkbox,
  FormControlLabel,
  IconButton,
  MenuItem,
  Select,
  SelectChangeEvent,
  Tab,
  Tabs,
  TextField,
} from "@mui/material";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  LocalizationProvider,
  DatePicker,
  DateTimePicker,
  TimePicker,
} from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import ResturantForm from "./resturantForm";
import IosSwitchMain from "../../../components/iosSwitchMain";
import EventForm from "./eventForm";
import EditText from "../../../components/editText";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import ExperienceForm from "./experienceForm";
import OthersForm from "./othersForm";
import { useFormik } from "formik";
import { showError, showToast } from "../../../constants/toasts";
import * as Yup from "yup";
import {
  useCreateOfferMutation,
  useLazyCloneOfferQuery,
  useLazyGetOfferByIdQuery,
  useTagsByGroupsMutation,
  useUpdateOfferMutation,
} from "../../../service/offer";
import dayjs, { Dayjs } from "dayjs";
import { useLazyGetTagGroupsQuery } from "../../../service/group&tags";
import { Categories, Offer, OfferData, TagGroup } from "../../../types/General";
import { useLazyGetCategoryQuery } from "../../../service/category";
import { GridCloseIcon } from "@mui/x-data-grid";
import {
  getFromStorage,
  removeFromStorage,
  setToStorage,
  STORAGE_KEYS,
} from "../../../helpers";
import { OFFER_STATUS, OFFER_TYPE } from "../../../utils/enums";
import { UploadOfferImage } from "../../../utils/mediaUpload";
import Loader from "../../../constants/Loader";
import { isQuillEmpty } from "../../../utils/validations";
interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

function BuildOffer() {
  const location = useLocation();
  const { id } = useParams();
  const [getGroups] = useLazyGetTagGroupsQuery();
  const [tagsByGroups] = useTagsByGroupsMutation();
  const [getCategory] = useLazyGetCategoryQuery();
  const [getOfferDetail] = useLazyGetOfferByIdQuery();
  const [createOffer] = useCreateOfferMutation();
  const [updateOffer] = useUpdateOfferMutation();
  const [cloneOffer] = useLazyCloneOfferQuery();

  const { state } = location;
  const navigate = useNavigate();
  const offerType = state?.type || "RESTAURANT";
  const categoryTab = state?.categoryTab || "";
  const status = state?.status || "";
  const categoryName = state?.categoryName || "";
  const categoryId = state?.categoryId;
  const isClone = state?.isClone;
  const offerData = getFromStorage(STORAGE_KEYS.offerData);
  const parsedData: OfferData | null = offerData
    ? (JSON.parse(offerData) as OfferData)
    : null;

  const goBack = () => {
    navigate("/manage-offer", {
      state: { status, categoryTab, categoryId, categoryName },
    });
  };

  const [isButterflyEnabled, setIsButterflyEnabled] = useState(false);
  const [valueTabs, setValueTabs] = React.useState(0);
  const [alignment, setAlignment] = useState("activate");
  const [offerStartDate, setOfferStartDate] = useState<Dayjs | null>(null);
  const [offerEndDate, setOfferEndDate] = useState<Dayjs | null>(null);
  const [butterflyStartDate, setButterflyStartDate] = useState<Dayjs | null>(
    null
  );
  const [butterflyEndDate, setButterflyEndDate] = useState<Dayjs | null>(null);
  const [autoCompleteOpen, setAutoCompleteOpen] = useState(true);
  const [groupData, setGroupData] = useState<TagGroup[]>([]);
  const [tags, setTags] = useState<TagGroup[]>([]);
  const [categoryData, setCategoryData] = useState<Categories[]>([]);
  const [selectedCategory, setSelectedCategory] = useState<string>("");
  const [startTime, setStartTime] = useState<Dayjs | null>(null);
  const [endTime, setEndTime] = useState<Dayjs | null>(null);
  const [selectedType, setSelectedType] = useState("");
  const [offerImages, setOfferImages] = useState<any[]>([]);
  const [error, setError] = useState(false);
  const [butterflyStartTime, setButterflyStartTime] = useState<Dayjs | null>(
    null
  );
  const [butterflyEndTime, setButterflyEndTime] = useState<Dayjs | null>(null);
  const [selectedGroupName, setSelectedGroupName] = useState<string[]>([]);
  const [selectedTagName, setSelectedTagName] = useState<string[]>([]);
  const [offerDetails, setOfferDetails] = useState<Offer | null>(null);
  const [loading, setLoading] = useState(false);
  const [selectedCategoryName, setSelectedCategoryName] = useState("");

  const modules = {
    toolbar: [
      [{ header: [1, 2, 3, false] }],
      ["bold", "italic", "underline", "strike"],
      [{ color: [] }, { background: [] }], // <-- Text & background color
      ["link", "image"],
      ["clean"], // remove formatting
    ],
  };

  const formats = [
    "header",
    "bold",
    "italic",
    "underline",
    "strike",
    "color",
    "background",
    "link",
    "image",
  ];

  const handleChange = (
    event: React.MouseEvent<HTMLElement>,
    newAlignment: string | null
  ) => {
    if (newAlignment !== null) {
      setAlignment(newAlignment);
    }
  };

  const handleChangeCategory = (event: SelectChangeEvent) => {
    const { value } = event.target;
    setSelectedCategory(value);
    const selected = categoryData?.find((item) => item?.id === value);
    if (selected) {
      setSelectedCategoryName(selected.name);
    }
  };

  const handleChangeType = (event: SelectChangeEvent) => {
    const { value } = event.target;
    setSelectedType(value);
  };

  const [selectedGroups, setSelectedGroups] = useState<string[]>([]);
  const [description, setDescription] = useState<string>("");
  const handleGroupChange = (event: any, value: any[]) => {
    const selectedGroups = value?.map((group) => group?.id);
    const selectedNames = value?.map((group) => group?.name);
    setSelectedGroups(selectedGroups);
    setSelectedGroupName(selectedNames);
  };
  const handleTagChange = (event: any, value: any[]) => {
    const selectedTags = value?.map((group) => group?.id);
    const selectedNames = value?.map((group) => group?.name);
    setSelectedTags(selectedTags);
    setSelectedTagName(selectedNames);
  };
  const [selectedTags, setSelectedTags] = useState<string[]>([]);

  const handleFileUpload = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const files = event.target.files;
    if (!files || files.length === 0) {
      setOfferImages([]);
      return;
    }

    // Convert FileList to array
    let fileArray = Array.from(files);

    const MAX_SIZE = 2 * 1024 * 1024; // 2MB in bytes
    const oversizedFiles = fileArray.filter((file) => file.size > MAX_SIZE);

    if (oversizedFiles.length > 0) {
      showError("Image must be less than 2MB.");
      // Remove oversized files
      fileArray = fileArray.filter((file) => file.size <= MAX_SIZE);
    }

    // Check limit (max 5 images)
    setOfferImages((prev) => {
      if (prev.length + fileArray.length > 5) {
        const allowedCount = 5 - prev.length;
        fileArray = fileArray.slice(0, allowedCount); // only allow remaining slots
        showError("You can only upload up to 5 images.");
      }
      return prev;
    });

    if (fileArray.length === 0) return;

    // Upload all images (parallel)
    const uploadResults = await Promise.all(
      fileArray.map(async (file) => {
        const res = (await UploadOfferImage(file)) as any;
        return res?.data || [];
      })
    );

    // Flatten arrays
    const uploadedImages = uploadResults.flat();

    // Push to state
    setOfferImages((prev) => [...prev, ...uploadedImages]);

    event.target.value = "";
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      title: parsedData?.Title || offerDetails?.title || "",
      badge: parsedData?.Badge || offerDetails?.badge || "",
      subtitle: parsedData?.Subtitle || offerDetails?.subtitle || "",
      buttonName: parsedData?.ButtonName || offerDetails?.buttonName || "",
    },
    validationSchema: Yup.object({
      title: Yup.string().required().required("Title is required"),
      badge: Yup.string().required().required("Location is required"),
      subtitle: Yup.string().required().required("Subtitle is required"),
      buttonName: Yup.string().required().required("Button Name is required"),
    }),

    onSubmit: async (values) => {
      formik.setSubmitting(true);

      if (
        !selectedCategory ||
        !selectedType ||
        !offerStartDate ||
        !startTime ||
        (isButterflyEnabled && (!butterflyStartDate || !butterflyStartTime)) ||
        !selectedGroups?.length ||
        !selectedTags?.length
      ) {
        return;
      }

      if (isQuillEmpty(description)) {
        return;
      }

      if (!id && dayjs(offerStartDate).isBefore(dayjs(), "day")) {
        return;
      }

      if (dayjs(offerEndDate).isBefore(dayjs(offerStartDate), "day")) {
        return;
      }

      if (!offerImages?.length) {
        showError("Please upload images");
        return;
      }

      const newBody = {
        Title: values.title,
        Badge: values.badge,
        Description: description,
        Subtitle: values.subtitle,
        CategoryId: selectedCategory,
        OfferType: selectedType,
        SelectedCategoryName: selectedCategoryName,
        OfferDisplayStartDate: offerStartDate
          ? dayjs(offerStartDate).toISOString()
          : "",
        OfferDisplayEndDate: offerEndDate
          ? dayjs(offerEndDate).toISOString()
          : "",
        IsButterflyEffect: isButterflyEnabled,
        ...(isButterflyEnabled
          ? {
              ButterflyEffectStartDate: butterflyStartDate
                ? dayjs(butterflyStartDate).toISOString()
                : "",
            }
          : {}),

        ...(isButterflyEnabled
          ? {
              ButterflyEffecteEndDate: butterflyEndDate
                ? dayjs(butterflyEndDate).toISOString()
                : "",
            }
          : {}),
        ButtonName: values.buttonName,
        offerImages: offerImages,
        GroupsId: selectedGroups,
        TagsId: selectedTags,
        OfferDisplayTime: startTime ? dayjs(startTime).toISOString() : "",
        OfferDisplayEndTime: endTime ? dayjs(endTime).toISOString() : "",
        ButterflyEffectStartTime: butterflyStartTime
          ? dayjs(butterflyStartTime).toISOString()
          : "",
        ButterflyEffectEndTime: butterflyEndTime
          ? dayjs(butterflyEndTime).toISOString()
          : "",
        tagNames: selectedTagName || [],
        groupNames: selectedGroupName || [],
      };

      const prevData = getFromStorage(STORAGE_KEYS.offerData);
      let parsedPrevData = {};

      if (prevData) {
        try {
          parsedPrevData = JSON.parse(prevData);
        } catch (err) {
          console.error("Error parsing stored offer data:", err);
        }
      }

      // Merge old and new data
      const mergedData = {
        ...parsedPrevData,
        ...newBody,
      };

      setValueTabs((prev) => prev + 1);
      setToStorage(STORAGE_KEYS.offerData, JSON.stringify(mergedData));
    },
  });

  const handleArchive = async () => {
    const formData = new FormData();

    const appendIfPresent = (key: string, value: any) => {
      if (value !== undefined && value !== null && value !== "") {
        formData.append(key, value);
      }
    };

    const appendArray = (key: string, arr?: any[]) => {
      if (Array.isArray(arr)) {
        arr.forEach((item) => {
          if (item !== undefined && item !== null && item !== "") {
            formData.append(key, item);
          }
        });
      }
    };

    appendIfPresent("Title", formik.values.title);
    appendIfPresent("Badge", formik.values.badge);
    appendIfPresent("Description", description);
    appendIfPresent("Subtitle", formik.values.subtitle);
    appendIfPresent("CategoryId", selectedCategory);
    appendIfPresent("OfferType", selectedType);

    appendIfPresent(
      "OfferDisplayStartDate",
      offerStartDate ? dayjs(startTime).toISOString() : null
    );

    appendIfPresent(
      "OfferDisplayEndDate",
      offerEndDate ? dayjs(endTime).toISOString() : null
    );

    appendIfPresent("IsButterflyEffect", isButterflyEnabled ? "true" : "false");

    appendIfPresent(
      "ButterflyEffectStartDate",
      butterflyStartDate ? dayjs(butterflyStartTime).toISOString() : null
    );

    appendIfPresent(
      "ButterflyEffectEndDate", // fixed the duplicate key name
      butterflyEndDate ? dayjs(butterflyEndTime).toISOString() : null
    );

    appendIfPresent("ButtonName", formik.values.buttonName);
    appendArray("GroupsId", selectedGroups);
    appendArray("TagsId", selectedTags);
    appendArray("offerImages", offerImages);

    appendIfPresent(
      "OfferDisplayTime",
      startTime ? dayjs(startTime).format("HH:mm:ss") : null
    );

    appendIfPresent(
      "OfferDisplayEndTime",
      endTime ? dayjs(endTime).format("HH:mm:ss") : null
    );
    appendIfPresent(
      "ButterflyEffectStartTime",
      butterflyStartTime ? dayjs(butterflyStartTime).format("HH:mm:ss") : null
    );
    appendIfPresent(
      "ButterflyEffectEndTime",
      butterflyEndTime ? dayjs(butterflyEndTime).format("HH:mm:ss") : null
    );

    appendIfPresent(
      "IsActive",
      alignment === OFFER_STATUS.ACTIVE ? "true" : "false"
    );
    appendIfPresent(
      "IsArchive",
      alignment === OFFER_STATUS.ARCHIVE ? "true" : "false"
    );

    appendIfPresent("OfferId", id);

    if (!id || isClone) {
      try {
        setLoading(true);
        const response = await createOffer(formData).unwrap();
        setLoading(false);
        if (response?.status === 200) {
          removeFromStorage(STORAGE_KEYS.offerData);
          // navigate("/manage-offer/preview-offer-detail");
          showToast(response?.message || "");
          navigate("/manage-offer", {
            state: { status, categoryTab, categoryId, categoryName },
          });
        } else {
          showError(response?.message || "");
        }
      } catch (error: any) {
        setLoading(false);
        showError(error?.data?.message || "");
        console.error(error);
      }
    } else {
      try {
        setLoading(true);
        const response = await updateOffer(formData).unwrap();
        setLoading(false);
        if (response?.status === 200) {
          removeFromStorage(STORAGE_KEYS.offerData);
          // navigate("/manage-offer/preview-offer-detail");
          showToast(response?.message || "");
          navigate("/manage-offer", {
            state: { status, categoryTab, categoryId, categoryName },
          });
        } else {
          showError(response?.message || "");
        }
      } catch (error: any) {
        setLoading(false);
        showError(error?.data?.message || "");
        console.error(error);
      }
    }
  };

  const getGroupApi = async () => {
    try {
      const response = await getGroups({
        page: 1,
        search: "",
      }).unwrap();
      if (response.status === 200) {
        const activeGroups =
          response?.data?.items?.filter(
            (group: any) => group?.isActive === true
          ) || [];

        setGroupData(activeGroups);
      } else {
        setGroupData([]);
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
    }
  };

  const cloneOfferApi = async () => {
    try {
      const response = await cloneOffer({ offerId: id }).unwrap();
      if (response.status === 200) {
        removeFromStorage(STORAGE_KEYS.offerData);
        // navigate("/manage-offer/preview-offer-detail");
        showToast(response?.message || "");
        navigate("/manage-offer", {
          state: { status: 3, categoryTab, categoryId, categoryName },
        });
      } else {
        showError(response?.message || "");
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
    }
  };

  const tagsByGroupsApi = async () => {
    const body = {
      GroupId: selectedGroups,
    };

    try {
      const response = await tagsByGroups(body).unwrap();
      if (response.status === 200) {
        const activeTags =
          response?.data?.filter((tag: any) => tag?.isActive === true) || [];

        setTags(activeTags);
      } else {
        setTags([]);
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
    }
  };

  const getCategoryApi = async () => {
    try {
      const response = await getCategory({ search: "" }).unwrap();
      if (response.status === 200) {
        const activeCategory = response?.data?.filter(
          (category: any) => category?.isActive === true
        );
        setCategoryData(activeCategory);
        // setCount(response?.data?.totalCount);
      } else {
        setCategoryData([]);
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
    }
  };

  const getOfferDetailApi = async () => {
    try {
      const response = await getOfferDetail({
        offerId: id,
      }).unwrap();

      if (response.status === 200) {
        setOfferDetails(response?.data);
        let groups = response?.data?.offerGroups?.map((item: any) => item?.id);
        let tags = response?.data?.offerTags?.map((item: any) => item?.id);
        let groupsName = response?.data?.offerGroups?.map(
          (item: any) => item?.name
        );
        let tagsName = response?.data?.offerTags?.map(
          (item: any) => item?.name
        );
        let images = response?.data?.offerImages?.map(
          (item: any) => item?.offerImageUrl
        );

        setSelectedCategory(response?.data?.categoryId || "");
        setSelectedType(response?.data?.offerType || "");
        setOfferStartDate(
          response?.data?.offerStartDate
            ? dayjs(response?.data?.offerStartDate)
            : null
        );
        setOfferEndDate(
          response?.data?.offerEndDate
            ? dayjs(response?.data?.offerEndDate)
            : null
        );

        setStartTime(
          response?.data?.offerStartDate
            ? dayjs(response?.data?.offerStartDate)
            : null
        );

        setEndTime(
          response?.data?.offerEndDate
            ? dayjs(response?.data?.offerEndDate)
            : null
        );
        setIsButterflyEnabled(response?.data?.isButterflyEffect || false);

        setButterflyStartDate(
          response?.data?.butterflyEffectStartDate
            ? dayjs(response?.data?.butterflyEffectStartDate)
            : null
        );
        setButterflyEndDate(
          response?.data?.butterflyEffectEndDate
            ? dayjs(response?.data?.butterflyEffectEndDate)
            : null
        );
        setButterflyStartTime(
          response?.data?.butterflyEffectStartDate
            ? dayjs(response?.data?.butterflyEffectStartDate)
            : null
        );
        setButterflyEndTime(
          response?.data?.butterflyEffectEndDate
            ? dayjs(response?.data?.butterflyEffectEndDate)
            : null
        );
        setSelectedCategoryName(response?.data?.category?.name || "");
        setSelectedGroups(groups || []);
        setSelectedTags(tags || []);
        setDescription(response?.data?.description || "");
        setOfferImages(images || []);
        setAlignment(
          response?.data?.isArchive ? OFFER_STATUS.ARCHIVE : OFFER_STATUS.ACTIVE
        );
        setSelectedGroupName(groupsName || []);
        setSelectedTagName(tagsName || []);
      } else {
        setOfferDetails(null);
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
    }
  };

  useEffect(() => {
    if (id) {
      getOfferDetailApi();
    }
  }, []);

  useEffect(() => {
    getGroupApi();
    getCategoryApi();
  }, []);

  useEffect(() => {
    if (selectedGroups?.length) {
      tagsByGroupsApi();
    } else {
      setSelectedTags([]);
      setTags([]);
    }
  }, [selectedGroups]);

  useEffect(() => {
    setSelectedCategory(parsedData?.CategoryId || categoryId || "");
    if (categoryName) {
      setSelectedCategoryName(categoryName || "");
      setSelectedType(
        categoryName === "Dining"
          ? OFFER_TYPE.RESTAURANT
          : categoryName === "Events"
            ? OFFER_TYPE.EVENTS
            : ""
      );
    } else {
      setSelectedType(parsedData?.OfferType || "");
    }

    setOfferStartDate(
      parsedData?.OfferDisplayStartDate
        ? dayjs(parsedData?.OfferDisplayStartDate)
        : null
    );
    setOfferEndDate(
      parsedData?.OfferDisplayEndDate
        ? dayjs(parsedData?.OfferDisplayEndDate)
        : null
    );
    setStartTime(
      parsedData?.OfferDisplayTime ? dayjs(parsedData?.OfferDisplayTime) : null
    );
    setEndTime(
      parsedData?.OfferDisplayEndTime
        ? dayjs(parsedData?.OfferDisplayEndTime)
        : null
    );

    setButterflyStartDate(
      parsedData?.ButterflyEffectStartDate
        ? dayjs(parsedData?.ButterflyEffectStartDate)
        : null
    );
    setButterflyEndDate(
      parsedData?.ButterflyEffecteEndDate
        ? dayjs(parsedData?.ButterflyEffecteEndDate)
        : null
    );
    setButterflyStartTime(
      parsedData?.ButterflyEffectStartTime
        ? dayjs(parsedData?.ButterflyEffectStartTime)
        : null
    );
    setButterflyEndTime(
      parsedData?.ButterflyEffectEndTime
        ? dayjs(parsedData?.ButterflyEffectEndTime)
        : null
    );
    setSelectedGroups(parsedData?.GroupsId || []);
    setSelectedTags(parsedData?.TagsId || []);
    setDescription(parsedData?.Description || "");
    setAlignment(
      parsedData?.IsArchive ? OFFER_STATUS.ARCHIVE : OFFER_STATUS.ACTIVE
    );
    setOfferImages(parsedData?.offerImages || []);
    setSelectedGroupName(parsedData?.groupNames || []);
    setSelectedTagName(parsedData?.tagNames || []);
  }, []);

  return (
    <>
      <MainContainer>
        <Loader isLoad={loading} />
        <div className="main_title d_flex">
          <div className="left_s">
            <h1 className="back_arrow">
              {" "}
              <IconButton
                onClick={() => {
                  if (valueTabs === 0) {
                    goBack();
                  } else {
                    setValueTabs(0);
                  }
                }}
              >
                {" "}
                <ArrowBackIcon />{" "}
              </IconButton>{" "}
              Build Offer
            </h1>
          </div>

          <div className="archv_ryt" style={{ display: "flex", gap: 20 }}>
            {valueTabs === 0 ? (
              <div className="btn_flex">
                {alignment === "archived" && (
                  <Button
                    className="btn btn_primary"
                    onClick={() => {
                      if (id) {
                        cloneOfferApi();
                      } else {
                        handleArchive();
                      }
                    }}
                  >
                    Save & Exit
                  </Button>
                )}
                <Button
                  className="btn btn_primary"
                  type="submit"
                  onClick={() => {
                    formik.submitForm();
                    setError(true);
                  }}
                >
                  Next
                </Button>
              </div>
            ) : null}

            <ToggleButtonGroup
              color="primary"
              value={alignment}
              exclusive
              onChange={handleChange}
              aria-label="Platform"
            >
              <ToggleButton value="activate">Activate</ToggleButton>
              <ToggleButton value="archived">Archived</ToggleButton>
            </ToggleButtonGroup>
          </div>
        </div>

        <Box
          className="ds_none custom_tabs2 mt_40 mb_30"
          sx={{ width: "100%" }}
        >
          <Tabs
            aria-label="basic tabs example"
            className="custom_tabs_links"
            value={valueTabs}
            onChange={(e, newValue) => setValueTabs(newValue)}
          >
            <Tab {...a11yProps(0)} />
            <Tab {...a11yProps(1)} />
            <Tab {...a11yProps(2)} />
          </Tabs>
        </Box>

        <div className="cards">
          <CustomTabPanel value={valueTabs} index={0}>
            <form>
              <div className="gap_m">
                <div className="control_group w_33">
                  <label>Title</label>
                  <TextField
                    placeholder="Enter Title"
                    hiddenLabel
                    fullWidth
                    value={formik.values.title}
                    id="title"
                    name="title"
                    className="text_field"
                    inputProps={{ maxLength: 40 }}
                    onChange={(val) => {
                      if (
                        val.target.value === " " ||
                        val.target.value === "."
                      ) {
                      } else {
                        formik.handleChange(val);
                      }
                    }}
                    onBlur={formik.handleBlur}
                    helperText={
                      formik.touched.title &&
                      typeof formik.errors.title === "string"
                        ? formik.errors.title
                        : ""
                    }
                  />
                </div>

                <div className="control_group w_33">
                  <label>Location</label>
                  <TextField
                    placeholder="Enter Location"
                    hiddenLabel
                    fullWidth
                    value={formik.values.badge}
                    id="badge"
                    name="badge"
                    className="text_field"
                    inputProps={{ maxLength: 40 }}
                    onChange={(val) => {
                      if (
                        val.target.value === " " ||
                        val.target.value === "."
                      ) {
                      } else {
                        formik.handleChange(val);
                      }
                    }}
                    onBlur={formik.handleBlur}
                    helperText={
                      formik.touched.badge &&
                      typeof formik.errors.badge === "string"
                        ? formik.errors.badge
                        : ""
                    }
                  />
                </div>

                <div className="control_group w_33">
                  <label>Subtitle</label>
                  <TextField
                    placeholder="Enter Subtitle"
                    hiddenLabel
                    fullWidth
                    value={formik.values.subtitle}
                    id="subtitle"
                    name="subtitle"
                    className="text_field"
                    inputProps={{ maxLength: 40 }}
                    onChange={(val) => {
                      if (
                        val.target.value === " " ||
                        val.target.value === "."
                      ) {
                      } else {
                        formik.handleChange(val);
                      }
                    }}
                    onBlur={formik.handleBlur}
                    helperText={
                      formik.touched.subtitle &&
                      typeof formik.errors.subtitle === "string"
                        ? formik.errors.subtitle
                        : ""
                    }
                  />
                </div>

                <div className="control_group w_33">
                  <label>Category</label>
                  <Select
                    className="dropse"
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    inputProps={{
                      "aria-label": "Without label",
                    }}
                    displayEmpty
                    value={selectedCategory}
                    name="page"
                    onChange={handleChangeCategory}
                  >
                    <MenuItem value="" disabled>
                      Select Category
                    </MenuItem>

                    {categoryData?.map((item) => {
                      return (
                        <MenuItem value={item?.id} key={item?.id}>
                          {item?.name || "-"}
                        </MenuItem>
                      );
                    })}
                  </Select>
                  {error && !selectedCategory ? (
                    <p className="err_msg">Category is required</p>
                  ) : (
                    ""
                  )}
                </div>
                <div className="control_group w_66">
                  <label>Type</label>

                  <Select
                    className="dropse"
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    inputProps={{
                      "aria-label": "Without label",
                    }}
                    displayEmpty
                    name="type"
                    value={selectedType}
                    onChange={handleChangeType}
                  >
                    <MenuItem value="" disabled>
                      Select Type
                    </MenuItem>

                    <MenuItem value="Restaurant"> Restaurant</MenuItem>
                    <MenuItem value="Events">Events</MenuItem>
                    <MenuItem value="Contact Dealers">Contact Dealers</MenuItem>
                    <MenuItem value="Others">Others</MenuItem>
                  </Select>
                  {error && !selectedType ? (
                    <p className="err_msg">Category is required</p>
                  ) : (
                    ""
                  )}
                </div>

                <div className="w_100 control_group">
                  <label>Offer Display Period</label>
                  <div className="gap_m">
                    <div className="w_50 control_group date_field">
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                          className="form_control"
                          format="DD/MM/YYYY"
                          minDate={dayjs()}
                          value={offerStartDate}
                          slotProps={{
                            textField: {
                              placeholder: "Start Date",
                              sx: {
                                "& .MuiInputBase-input.Mui-disabled": {
                                  WebkitTextFillColor: "#9999", // change text & placeholder color
                                  opacity: 1,
                                },
                              },
                            },
                          }}
                          onChange={(newValue) => setOfferStartDate(newValue)}
                          slots={{
                            openPickerIcon: () => (
                              <img
                                src="/static/images/calendar_icon.svg"
                                alt="icon"
                              />
                            ),
                            // textField: (params) => (
                            //   <TextField
                            //     {...params}
                            //     fullWidth
                            //     placeholder="Start Date"
                            //     hiddenLabel
                            //   />
                            // ),
                          }}
                          desktopModeMediaQuery="(min-width:0px)"
                        />
                      </LocalizationProvider>
                      {error && !offerStartDate ? (
                        <p className="err_msg">Start Date is required</p>
                      ) : !id &&
                        error &&
                        offerStartDate &&
                        dayjs(offerStartDate).isBefore(dayjs(), "day") ? (
                        <p className="err_msg">
                          Start Date cannot be earlier than today
                        </p>
                      ) : (
                        ""
                      )}
                    </div>

                    <div className="w_50 control_group date_field">
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <TimePicker
                          value={startTime}
                          onChange={(newValue) => {
                            if (offerStartDate) {
                              setStartTime(
                                dayjs(offerStartDate)
                                  .hour(dayjs(newValue).hour())
                                  .minute(dayjs(newValue).minute())
                              );
                            }
                          }}
                          slotProps={{
                            textField: {
                              placeholder: "Start Time",
                              sx: {
                                "& .MuiInputBase-input.Mui-disabled": {
                                  WebkitTextFillColor: "#9999", // change text & placeholder color
                                  opacity: 1,
                                },
                              },
                            },
                          }}
                          slots={{
                            openPickerIcon: () => (
                              <img
                                src="/static/images/calendar_icon.svg"
                                alt="icon"
                              />
                            ),
                          }}
                          disabled={!offerStartDate}
                        />
                      </LocalizationProvider>
                      {error && !startTime ? (
                        <p className="err_msg">Start Time is required</p>
                      ) : (
                        ""
                      )}
                    </div>

                    <div className="w_50 control_group date_field">
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                          className="form_control"
                          value={offerEndDate}
                          onChange={(newValue) => setOfferEndDate(newValue)}
                          format="DD/MM/YYYY"
                          minDate={dayjs(offerStartDate)}
                          slotProps={{
                            textField: {
                              placeholder: "End Date",
                              sx: {
                                "& .MuiInputBase-input.Mui-disabled": {
                                  WebkitTextFillColor: "#9999", // change text & placeholder color
                                  opacity: 1,
                                },
                              },
                            },
                          }}
                          slots={{
                            openPickerIcon: () => (
                              <img
                                src="/static/images/calendar_icon.svg"
                                alt="icon"
                              />
                            ),
                            // textField: (params) => (
                            //   <TextField
                            //     {...params}
                            //     fullWidth
                            //     placeholder="End Date"
                            //     hiddenLabel
                            //   />
                            // ),
                          }}
                          desktopModeMediaQuery="(min-width:0px)"
                          disabled={!offerStartDate}
                        />
                        {error &&
                        offerEndDate &&
                        dayjs(offerEndDate).isBefore(
                          dayjs(offerStartDate),
                          "day"
                        ) ? (
                          <p className="err_msg">
                            End Date cannot be earlier than start date
                          </p>
                        ) : (
                          ""
                        )}
                      </LocalizationProvider>
                    </div>

                    <div className="w_50 control_group date_field">
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <TimePicker
                          value={endTime}
                          minTime={
                            offerStartDate &&
                            offerEndDate &&
                            startTime &&
                            dayjs(offerStartDate).isSame(offerEndDate, "day")
                              ? dayjs(startTime).add(1, "minute")
                              : null
                          }
                          onChange={(newValue) => {
                            if (offerEndDate) {
                              setEndTime(
                                dayjs(offerEndDate)
                                  .hour(dayjs(newValue).hour())
                                  .minute(dayjs(newValue).minute())
                              );
                            }
                          }}
                          slotProps={{
                            textField: {
                              placeholder: "End Time",
                              sx: {
                                "& .MuiInputBase-input.Mui-disabled": {
                                  WebkitTextFillColor: "#9999", // change text & placeholder color
                                  opacity: 1,
                                },
                              },
                            },
                          }}
                          slots={{
                            openPickerIcon: () => (
                              <img
                                src="/static/images/calendar_icon.svg"
                                alt="icon"
                              />
                            ),
                          }}
                          disabled={!startTime}
                        />
                      </LocalizationProvider>
                    </div>
                  </div>
                </div>

                <div className="control_group w_100">
                  <div className="gap_m">
                    <div className="control_group w_50 d_flex">
                      <label className="mb_0">Butterfly Effect</label>
                      <IosSwitchMain
                        checked={isButterflyEnabled}
                        onChange={(e) =>
                          setIsButterflyEnabled(e.target.checked)
                        }
                      />
                    </div>
                  </div>
                </div>
                {isButterflyEnabled && (
                  <div className="w_100 control_group">
                    <label>Butterfly Effect Active Dates</label>
                    <div className="gap_m">
                      <div className="w_50 control_group date_field">
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DatePicker
                            className="form_control"
                            format="DD/MM/YYYY"
                            value={butterflyStartDate}
                            onChange={(newValue) =>
                              setButterflyStartDate(newValue)
                            }
                            minDate={dayjs()}
                            slotProps={{
                              textField: {
                                placeholder: "Start Date",
                                sx: {
                                  "& .MuiInputBase-input.Mui-disabled": {
                                    WebkitTextFillColor: "#9999", // change text & placeholder color
                                    opacity: 1,
                                  },
                                },
                              },
                            }}
                            slots={{
                              openPickerIcon: () => (
                                <img
                                  src="/static/images/calendar_icon.svg"
                                  alt="icon"
                                />
                              ),
                            }}
                            desktopModeMediaQuery="(min-width:0px)"
                          />
                          {error && !butterflyStartDate ? (
                            <p className="err_msg">Start Date is required</p>
                          ) : (
                            ""
                          )}
                        </LocalizationProvider>
                      </div>

                      <div className="w_50 control_group date_field">
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <TimePicker
                            value={butterflyStartTime}
                            onChange={(newValue) => {
                              if (butterflyStartDate) {
                                setButterflyStartTime(
                                  dayjs(butterflyStartDate)
                                    .hour(dayjs(newValue).hour())
                                    .minute(dayjs(newValue).minute())
                                );
                              }
                            }}
                            slotProps={{
                              textField: {
                                placeholder: "Start Time",
                                sx: {
                                  "& .MuiInputBase-input.Mui-disabled": {
                                    WebkitTextFillColor: "#9999", // change text & placeholder color
                                    opacity: 1,
                                  },
                                },
                              },
                            }}
                            slots={{
                              openPickerIcon: () => (
                                <img
                                  src="/static/images/calendar_icon.svg"
                                  alt="icon"
                                />
                              ),
                            }}
                            disabled={!butterflyStartDate}
                          />
                        </LocalizationProvider>
                        {error && !butterflyStartTime ? (
                          <p className="err_msg">Start Time is required</p>
                        ) : (
                          ""
                        )}
                      </div>

                      <div className="w_50 control_group date_field">
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DatePicker
                            className="form_control"
                            value={butterflyEndDate}
                            onChange={(newValue) =>
                              setButterflyEndDate(newValue)
                            }
                            minDate={dayjs(butterflyStartDate)}
                            format="DD/MM/YYYY"
                            slotProps={{
                              textField: {
                                placeholder: "End Date",
                                sx: {
                                  "& .MuiInputBase-input.Mui-disabled": {
                                    WebkitTextFillColor: "#9999", // change text & placeholder color
                                    opacity: 1,
                                  },
                                },
                              },
                            }}
                            slots={{
                              openPickerIcon: () => (
                                <img
                                  src="/static/images/calendar_icon.svg"
                                  alt="icon"
                                />
                              ),
                            }}
                            desktopModeMediaQuery="(min-width:0px)"
                            disabled={!butterflyStartDate}
                          />
                        </LocalizationProvider>
                      </div>

                      <div className="w_50 control_group date_field">
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <TimePicker
                            value={butterflyEndTime}
                            onChange={(newValue) => {
                              if (butterflyEndDate) {
                                setButterflyEndTime(
                                  dayjs(butterflyEndDate)
                                    .hour(dayjs(newValue).hour())
                                    .minute(dayjs(newValue).minute())
                                );
                              }
                            }}
                            slotProps={{
                              textField: {
                                placeholder: "End Time",
                                sx: {
                                  "& .MuiInputBase-input.Mui-disabled": {
                                    WebkitTextFillColor: "#9999", // change text & placeholder color
                                    opacity: 1,
                                  },
                                },
                              },
                            }}
                            slots={{
                              openPickerIcon: () => (
                                <img
                                  src="/static/images/calendar_icon.svg"
                                  alt="icon"
                                />
                              ),
                            }}
                            disabled={!butterflyEndDate}
                          />
                        </LocalizationProvider>
                      </div>
                    </div>
                  </div>
                )}

                <div className="control_group w_50">
                  <label>Groups</label>
                  <Autocomplete
                    multiple
                    disableCloseOnSelect
                    options={groupData}
                    value={groupData?.filter((option) =>
                      selectedGroups?.includes(option?.id)
                    )}
                    onChange={handleGroupChange}
                    getOptionLabel={(option) => option?.name}
                    isOptionEqualToValue={(option: any, value: any) =>
                      option?.id === value?.id
                    }
                    onOpen={() => setAutoCompleteOpen(true)}
                    onClose={() => setAutoCompleteOpen(false)}
                    renderOption={(props, option: any, { selected }) => {
                      return (
                        <li {...props}>
                          <FormControlLabel
                            control={<Checkbox checked={selected} />}
                            name="option"
                            label={option?.name}
                          />
                        </li>
                      );
                    }}
                    renderInput={(params) => (
                      <TextField {...params} placeholder="Select Groups" />
                    )}
                  />
                  {error && !selectedGroups?.length ? (
                    <p className="err_msg">Group is required</p>
                  ) : (
                    ""
                  )}
                </div>

                <div className="control_group w_50">
                  <label>Tags</label>
                  <Autocomplete
                    multiple
                    disableCloseOnSelect
                    options={tags}
                    value={tags?.filter((option) =>
                      selectedTags?.includes(option?.id)
                    )}
                    onChange={handleTagChange}
                    getOptionLabel={(option) => option?.name}
                    isOptionEqualToValue={(option: any, value: any) =>
                      option?.id === value?.id
                    }
                    onOpen={() => setAutoCompleteOpen(true)}
                    onClose={() => setAutoCompleteOpen(false)}
                    renderOption={(props, option: any, { selected }) => {
                      return (
                        <li {...props}>
                          <FormControlLabel
                            control={<Checkbox checked={selected} />}
                            name="option"
                            label={option?.name}
                          />
                        </li>
                      );
                    }}
                    renderInput={(params) => (
                      <TextField {...params} placeholder="Select Tags" />
                    )}
                  />
                  {error && !selectedTags?.length ? (
                    <p className="err_msg">Tags are required</p>
                  ) : (
                    ""
                  )}
                </div>

                <div className="control_group w_100">
                  <label>Description</label>
                  <ReactQuill
                    value={description}
                    onChange={setDescription}
                    theme="snow"
                    modules={modules}
                    formats={formats}
                  />
                  {error && isQuillEmpty(description) && (
                    <p className="err_msg">Description is required</p>
                  )}
                </div>

                <div className="control_group w_100">
                  <label>Image Upload</label>
                  <div className="gap_m">
                    <div className="control_group w_33">
                      <figure className="upload_image v2 centered">
                        <input
                          id="icon-button-file"
                          type="file"
                          accept="image/png,image/jpeg"
                          multiple
                          onChange={handleFileUpload}
                        />
                        <figcaption>
                          <AddCircleOutlineIcon />
                          <p>Add Image</p>
                        </figcaption>
                      </figure>
                    </div>
                  </div>

                  {offerImages?.map((img: any, idx) => (
                    <div
                      key={idx}
                      className="upload_image no_radius v2"
                      style={{
                        position: "relative",
                        width: 200,
                        height: 100,
                        minWidth: 120,
                        minHeight: 120,
                        border: "1.5px solid #ccc",

                        overflow: "visible",
                        background: "#fff",
                        flex: "0 0 auto",
                        marginRight: 20,
                      }}
                    >
                      <IconButton
                        size="small"
                        style={{
                          position: "absolute",
                          top: -10,
                          right: -10,
                          background: "#006039",
                          color: "#fff",
                          zIndex: 2,
                          boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
                          width: 28,
                          height: 28,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                        onClick={() => {
                          setOfferImages(
                            offerImages?.filter((_, i) => i !== idx)
                          );
                        }}
                      >
                        <GridCloseIcon fontSize="small" />
                      </IconButton>
                      <div
                        className="upload_image_holder"
                        style={{ width: "100%", height: "100%" }}
                      >
                        <CardMedia
                          component="img"
                          image={img}
                          alt={""}
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                          }}
                        />
                      </div>
                    </div>
                  ))}
                </div>

                <div className="control_group w_100">
                  <div className="btn_name">
                    <div className="btn_lft w_50">
                      <label>Button Name</label>
                      <TextField
                        placeholder="Enter button name"
                        hiddenLabel
                        fullWidth
                        value={formik.values.buttonName}
                        id="buttonName"
                        name="buttonName"
                        className="text_field"
                        inputProps={{ maxLength: 40 }}
                        onChange={(val) => {
                          if (
                            val.target.value === " " ||
                            val.target.value === "."
                          ) {
                          } else {
                            formik.handleChange(val);
                          }
                        }}
                        onBlur={formik.handleBlur}
                        helperText={
                          formik.touched.buttonName &&
                          typeof formik.errors.buttonName === "string"
                            ? formik.errors.buttonName
                            : ""
                        }
                      />
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </CustomTabPanel>

          <CustomTabPanel value={valueTabs} index={1}>
            {selectedType === OFFER_TYPE.EVENTS ? (
              <EventForm
                alignment={alignment}
                offerDetails={offerDetails}
                updateId={id}
                isClone={isClone}
                tabs={valueTabs}
                setTabs={setValueTabs}
                categoryTab={categoryTab}
                status={status}
                categoryName={categoryName}
                categoryId={categoryId}
              />
            ) : selectedType === OFFER_TYPE.CONTACT_DEALERS ? (
              <ExperienceForm
                alignment={alignment}
                offerDetails={offerDetails}
                updateId={id}
                isClone={isClone}
                tabs={valueTabs}
                setTabs={setValueTabs}
                categoryTab={categoryTab}
                status={status}
                categoryName={categoryName}
                categoryId={categoryId}
              />
            ) : selectedType === OFFER_TYPE.OTHERS ? (
              <OthersForm
                alignment={alignment}
                offerDetails={offerDetails}
                updateId={id}
                isClone={isClone}
                tabs={valueTabs}
                setTabs={setValueTabs}
                categoryTab={categoryTab}
                status={status}
                categoryName={categoryName}
                categoryId={categoryId}
              />
            ) : (
              <ResturantForm
                alignment={alignment}
                offerDetails={offerDetails}
                updateId={id}
                isClone={isClone}
                tabs={valueTabs}
                setTabs={setValueTabs}
                categoryTab={categoryTab}
                status={status}
                categoryName={categoryName}
                categoryId={categoryId}
              />
            )}
          </CustomTabPanel>
        </div>
      </MainContainer>
    </>
  );
}

export default BuildOffer;
